import React, { useEffect, useState } from 'react';
import logo from '../assets/logo.png';
import '../style.css';
import { Link, useLocation, useNavigate } from "react-router-dom";

type NavItem = { label: string; path: string; anchor: string };

const NAV: NavItem[] = [
  { label: 'Home',     path: '/', anchor: 'home'     },
  { label: 'Team',     path: '/', anchor: 'team'     },
  { label: 'Services', path: '/', anchor: 'scope'    },   // maps to your existing #scope section
];

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollTarget, setScrollTarget] = useState<string | null>(null);
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToAnchor = (anchor: string) => {
    const el = document.getElementById(anchor);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const handleLinkClick = (path: string, anchor: string) => {
    if (location.pathname === path) {
      scrollToAnchor(anchor);
    } else {
      setScrollTarget(anchor);
      navigate(path);
    }
    setIsMenuOpen(false);
  };

  useEffect(() => {
      document.body.classList.toggle('is-menu-open', isMenuOpen);
      return () => document.body.classList.remove('is-menu-open');
    }, [isMenuOpen]);

  // Make logo click go "Home"
  const handleLogoClick = () => handleLinkClick('/', 'home');

  useEffect(() => {
    if (scrollTarget) {
      scrollToAnchor(scrollTarget);
      setScrollTarget(null);
    }
  }, [location, scrollTarget]);

  const toggleMenu = () => setIsMenuOpen(o => !o);

  return (
    <header className="osa-header">
      <div className="container">
        <nav className="navbar" aria-label="Primary">
          <button className="logo" onClick={handleLogoClick} aria-label="OSA Consulting Home">
            <img src={logo} alt="OSA Consulting Logo" />
            <span>OSA CONSULTING</span>
          </button>

          <div className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
            {isMenuOpen && (
              <button className="logo-in-menu" onClick={handleLogoClick} aria-label="OSA Consulting Home">
                <img src={logo} alt="OSA Consulting Logo" />
                <span>OSA CONSULTING</span>
              </button>
            )}
            <ul>
              {NAV.map(item => (
                <li key={item.anchor}>
                  <Link
                    to={item.path}
                    onClick={(e) => {
                      e.preventDefault();
                      handleLinkClick(item.path, item.anchor);
                    }}
                    className="nav-link"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <button
            className={`hamburger ${isMenuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
            aria-expanded={isMenuOpen}
            aria-controls="primary-navigation"
          >
            <span className="bar" />
            <span className="bar" />
            <span className="bar" />
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
